const dialog = document.getElementById('RestockRequestDialog');

if (dialog instanceof HTMLDialogElement) {
  const productLabel = dialog.querySelector('[data-restock-product]');
  const bodyInput = dialog.querySelector('[data-restock-body]');
  const form = dialog.querySelector('form');
  const storageKey = 'yourshonen-restock-request';

  const open = (trigger) => {
    if (productLabel) productLabel.textContent = trigger.dataset.productTitle || '';
    if (bodyInput) {
      const variantInput = trigger.closest('.buy-buttons-block')?.querySelector('input[name="id"]');
      const variantId = variantInput?.value || trigger.dataset.variantId || '';
      bodyInput.value = `Wiederverfuegbarkeits-Anfrage\nProdukt: ${trigger.dataset.productTitle || ''}\nProdukt-ID: ${trigger.dataset.productId || ''}\nVariante-ID: ${variantId}\nProdukt-URL: ${trigger.dataset.productUrl || ''}`;
    }
    if (!dialog.open) dialog.showModal();
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-restock-trigger]');
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      open(trigger);
    } else if (event.target.closest?.('[data-restock-close]')) {
      dialog.close();
    } else if (event.target === dialog) {
      dialog.close();
    }
  });

  form?.addEventListener('submit', () => {
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({
        title: productLabel?.textContent || '',
        body: bodyInput?.value || '',
      }));
    } catch (_) { /* Storage can be disabled. */ }
  });

  let pendingRequest = false;
  try { pendingRequest = sessionStorage.getItem(storageKey) !== null; } catch (_) { /* Storage can be disabled. */ }
  if (pendingRequest && dialog.querySelector('[data-restock-success], [data-restock-error]')) {
    try {
      const request = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
      if (productLabel) productLabel.textContent = request.title || '';
      if (bodyInput) bodyInput.value = request.body || '';
      sessionStorage.removeItem(storageKey);
    } catch (_) { /* Storage can be disabled. */ }
    dialog.showModal();
  } else if (pendingRequest) {
    try { sessionStorage.removeItem(storageKey); } catch (_) { /* Storage can be disabled. */ }
  }
}
